module.exports = __webpack_public_path__ + "img/smile.ebc189b3.png";